<template>
  <div>
    <header class="px-8 header" :style="!onlyLogoHeader ? 'height: 11rem;' : ''">
      <div class="d-flex justify-space-between align-center">
        <div style="height: 100px;" class="d-flex align-center justify-center w-100">
          <v-img
            v-if="!backToRoute"
            :src="logo"
            width="80"
            height="80"
            aspect-ratio="1"
            contain
            style="cursor: pointer"
            @click="
              $route.name != routeNames.WALLET &&
                $router.push({ name: routeNames.WALLET })
            "
          ></v-img>
          <v-icon
            v-else
            large
            color="primary"
            @click="goBack($router, backFrameRoute)"
            >arrow_back</v-icon
          >
        </div>
        
      </div>
      <div v-if="!onlyLogoHeader" class="d-flex align-center justify-center">
        <v-chip >
          {{ userName ? `${$t("headers.hello")} ${userName}` : $t("my_account.title") }}
        </v-chip>
      </div>
    </header>
    <div v-if="banner.active && !onlyLogoHeader" class="banner">
      <div class="scroll-wrapper" ref="wrapper">
        <div class="scroll-content" ref="content">
          <div class="banner-item" v-for="i in 2" :key="i">
            <span class="event-name">{{ eventName }}</span>
            <span class="circle"></span>
            <span class="message">{{ textBanner }}</span>
            <span class="circle"></span>
            &nbsp;&nbsp;&nbsp;
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import routeNames from "@/router/route-names";
import { mapState } from "vuex";
import { goBack } from "@/utils/commonMethods";
import bannerMixins from "@/mixins/StringUtils";

export default {
  props: {
    backToRoute: [Boolean],
    onlyLogoHeader: Boolean,
    backFrameRoute: String,
  },
  mixins: [bannerMixins],
  data() {
    return {
      routeNames: routeNames,
    };
  },
  methods: {
    goBack,
  },
  computed: {
    ...mapState(["customization"]),
    ...mapState({
      eventName: (state) => state.customization.customization.name,
      logo: (state) =>
        state.customization.customization
          ? state.customization.customization.logo
          : "/logo.png",
      userName: (state) => {
        
        const userData = state.userData && state.userData.userData;
        if (!userData) return null;

        if (userData.name) {
          return userData.name.length > 12
            ? `${userData.name.substr(0, 12)}...`
            : userData.name;
        }

        if (typeof userData.email === "string" && userData.email.includes("@")) {
          const emailName = userData.email.split("@")[0];
          return emailName.length > 12
            ? `${emailName.substr(0, 12)}...`
            : emailName;
        }

        return "";
      },
    }),
    banner() {
      return (
        this.customization &&
        this.customization.customization &&
        this.customization.customization.banner
      ) || {
        active: false,
        value: [
          { locale: "ES", content: null },
          { locale: "EN", content: null }
        ]
      }
    },
    textBanner() {
      return this.getLocalizedString(this.banner.value);
    }
  },
  async created() {
    try {
      if (!this.customization.customization) {
        await this.$store.dispatch("getCustomization", {
          context: this,
          getSaved: true,
        });
      }
      
    } catch (error) {
      console.error("Error cargando la configuración:", error);
    }
  },
  mounted() {
    if (this.banner.active && !this.onlyLogoHeader) {
      const wrapper = this.$refs.wrapper;
      const content = this.$refs.content;
  
      // Asegurar que el contenido se repite suficiente veces
      while (content.offsetWidth < wrapper.offsetWidth * 2) {
        content.innerHTML += content.innerHTML;
      }
  
      const duration = content.offsetWidth / 50; // velocidad proporcional
      content.style.animationDuration = `${duration}s`;
    }
  },
};
</script>
<style lang="css">
header {
  background-color: white !important;
}
.header {
  width: 100%;
  max-width: 390px;
  z-index: 1;
  padding-top: 1rem;
}
.banner {
  width: 390px;
  height: 50px;
  overflow: hidden;
  background-color: #000230; /* fondo oscuro para contraste */
  display: flex;
  align-items: center;
  color: white;
  font-size: 16px;
}

.scroll-wrapper {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.scroll-content {
  display: inline-block;
  white-space: nowrap;
  animation: scroll linear infinite;
}

.banner-item {
  display: inline-flex;
  align-items: center;
}

.event-name {
  font-weight: bold;
  margin-right: 6px;
}

.message {
  margin-left: 6px;
}

.circle {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: orange;
  border-radius: 50%;
  margin: 0 6px;
  flex-shrink: 0;
}

@keyframes scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}
</style>
